export const styles = {
  wrapper: {
    padding: '16px',
    borderRadius: '32px',
    width: '100%',
    height: '100%',
    backgroundColor: (theme) => theme.palette.white.paper,
  },
  content: {
    height: '100%',
    maxHeight: 'calc(100% - 56px)',
    overflow: 'scroll',
  },
  header: {
    display: 'flex',
    alignItems: 'start',
    gap: '8px',
    padding: '32px',
  },
  chipContainer: {
    display: 'flex',
    alignItems: 'start',
    gap: '8px',
    paddingTop: '2px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
    marginTop: '-0.4rem',
  },
  snippet: {
    padding: '0px 45px 0px 90px',
  },
  fullTextWrapper: { paddingLeft: '94px' },
  attachments: {
    padding: '32px',
  },
};
